import React, { Component } from 'react';

class Footer extends Component {
    render(){
        return (
            <footer className={"footer" + (this.props.transparent !== undefined ? " footer-transparent":"")}>
                <div className={"container" + (this.props.fluid !== undefined ? "-fluid":"")}>
                    <p className="copyright pull-right">
                        &copy; {1900 + (new Date()).getYear()} <a href="http://www.uncuyo.edu.ar/">UNCuyo | IncuSIG</a>
                    </p>
                </div>
            </footer>
        );
    }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx